import { AppUser, IOptionsWithTypes } from '@eventr/common'
import { useCallback } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { bs, useBoundStore } from '../../../state/bound.store'
export const useUserFilter = () => {
    const { getUserFromID, getUsersWithTags } = useBoundStore(
        useShallow((s) => {
            return {
                getUserFromID: s.getUserFromID,
                getUsersWithTags: s.getUsersWithTags,
            }
        })
    )

    const filterUsers = useCallback(
        (userList: IOptionsWithTypes[]) => {
            /// To filter for only users in the itinerary. (so doesnt show removed users)
            const itinUserIds = [
                ...bs()
                    .selectedItineraryUsers()
                    .map((user) => {
                        return user.id
                    }),
                ...bs()
                    .selectedItineraryUsersOnlyFromGroupsAndDepartments()
                    .map((user) => {
                        return user.id
                    }),
            ]

            const _users: AppUser[] = []
            const tagsDep: string[] = []
            const tagsGroup: string[] = []

            userList?.forEach((u) => {
                if (u && u.type === 'User') {
                    const user = getUserFromID(
                        Number.parseInt(u.option?.toString())
                    )

                    const inList = _users?.some((u) => {
                        return u?.id === user?.id
                    })
                    if (user && !inList) {
                        if (itinUserIds.includes(user.id)) _users.push(user)
                    }
                }
                if (u && u.type === 'Department') {
                    tagsDep.push(u.option?.toString())
                }
                if (u && u.type === 'Group') {
                    tagsGroup.push(u.option?.toString())
                }
            })
            const tagUsers = getUsersWithTags(tagsDep, tagsGroup)
            // only add users that are not already in the list
            tagUsers.forEach((u) => {
                if (!_users.find((user) => user.id === u.id)) {
                    _users.push(u)
                }
            })

            return _users
        },
        [getUserFromID, getUsersWithTags]
    )

    return { filterUsers }
}
